import { defineComponent as _defineComponent } from 'vue'
import CcModal from '@/views/Automation/CampaignCreatorV2/components/Modals/CcModal.ts.vue';
import GeneratePreview from '@sh/components/Utils/ContentPreview/GeneratePreview.ts.vue';
import PreviewAdCard from '@sh/components/Utils/ContentPreview/PreviewAdCard.ts.vue';
import VideoModal from '@sh/components/Utils/ContentPreview/VideoModal.vue';
import { getTrafficSourceLogo, isVideoUrl } from '@sh/helpers';
import { MediaManager, TrafficSource } from '@sh/types';
import { computed } from 'vue';

interface Props {
  isOpen: boolean;
  trafficSource: TrafficSource;
  trafficSourceAccountId?: number;
  previewContent: {
    traffic_source_account_id?: string;
    traffic_source_item_id?: string;
    traffic_source_content_id?: string;
    image_url: string;
    headline: string;
    cta?: string;
    target_url?: string;
    url?: string;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Index.ts',
  props: {
    isOpen: { type: Boolean },
    trafficSource: null,
    trafficSourceAccountId: null,
    previewContent: null
  },
  setup(__props: any) {

const props = __props as {
  isOpen: boolean;
  trafficSource: TrafficSource;
  trafficSourceAccountId?: number;
  previewContent: {
    traffic_source_account_id?: string;
    traffic_source_item_id?: string;
    traffic_source_content_id?: string;
    image_url: string;
    headline: string;
    cta?: string;
    target_url?: string;
    url?: string;
  };
};



const isGeneratePreview = computed(() => [TrafficSource.TikTok, TrafficSource.Facebook].includes(props.trafficSource));

const isVideo = computed(() => isVideoUrl(props.previewContent.image_url));

const contentId = computed(() =>
  String(props.previewContent.traffic_source_content_id ?? props.previewContent.traffic_source_item_id)
);

const accountId = computed(
  () => props.trafficSourceAccountId ?? Number(props.previewContent.traffic_source_account_id ?? -1)
);

const videoChannel = computed(() =>
  props.previewContent.image_url.includes('www.youtube.com') ? 'youtube' : 'direct'
);

const videoId = computed(() => {
  if (props.previewContent.image_url.includes('youtube')) {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = props.previewContent.image_url.match(regExp);
    return match && match[7].length === 11 ? match[7] : undefined;
  }
  return props.previewContent.image_url;
});

const ctaButton = computed(() => {
  return {
    text: props.previewContent.cta,
    link: props.previewContent.target_url || props.previewContent.url || props.previewContent.image_url,
  };
});

const itemAd = computed<MediaManager.ActiveAd>(() => ({
  headline: props.previewContent.headline,
  description: '',
  tags: [],
  campaignsList: [],
  errorMessage: '',
  isCampaignListLoading: false,
  id: props.previewContent.traffic_source_content_id ?? '',
  image: {
    base64: props.previewContent.image_url,
  },
  trafficSource: {
    name: props.trafficSource,
    imagePath: getTrafficSourceLogo(props.trafficSource),
  },
  metrics: [],
  usedOn: 0,
  isEditable: false,
  selected: false,
}));

return { __sfc: true,props, isGeneratePreview, isVideo, contentId, accountId, videoChannel, videoId, ctaButton, itemAd, CcModal, GeneratePreview, PreviewAdCard, VideoModal }
}

})